import React, { Component } from 'react';
import triangleIcon from 'src/imgs/sort-triangle-icon.svg';
import InlineSVG from 'react-svg-inline';
import styles from './SortLabel.scss';
import cx from 'classnames';
import _ from 'lodash';

const stopPropagation = (e) => e.stopPropagation();

export default class SortLabel extends Component {
  state = {
    areOptionsExposed: false,
    chosenOptions: [],
  };

  toggleOptionsExposing = () => this.setState({
    areOptionsExposed: !this.state.areOptionsExposed,
  });

  onClick = (e) => {
    this.toggleOptionsExposing();
    this.props.onClick && this.props.onClick(e);
  };

  onChange = ({ target }) => {
    const selectedOption = this.props.options[target.getAttribute('data-option-key')];

    const newChosenOptions = target.checked
      ? [...this.state.chosenOptions, selectedOption]
      : _.filter(this.state.chosenOptions, ({ value, label }) =>
      value !== selectedOption.value && label !== selectedOption.label);
    this.setState({
      chosenOptions: newChosenOptions,
    }, () => this.props.onChange && this.props.onChange(this.state.chosenOptions));
  };

  render() {
    const { children, className = '', isAsc,
      options = [], placeholder } = this.props;
    const rootClassName = cx([className, styles.root], {
      [styles.asc]: isAsc || this.state.areOptionsExposed,
    });
    const optionsContainerClassName = cx(styles.optionsContainer, {
      [styles.optionsOpen]: this.state.areOptionsExposed,
    });
    const renderedOptions = _.map(options, ({ value, label }, i) => (
      <label
        onClick={ stopPropagation }
        className={ styles.option }
      >
        <input
          className={ styles.optionCheckbox }
          type="checkbox"
          value={ value }
          data-option-key={ i }
          key={`option_${label}`}
          onChange={ this.onChange }
          checked={_.some(this.state.chosenOptions, (opt) =>
            opt.value === value && opt.label === label
          )}
        />
        <span>
          { label }
        </span>
      </label>
    ));

    return (
      <span className={ rootClassName } onClick={ this.onClick }>
        <span>
          { children || placeholder }
          <InlineSVG svg={ triangleIcon } />
        </span>
        <div className={ optionsContainerClassName }>
          { renderedOptions }
        </div>
      </span>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SortLabel/SortLabel.jsx
 **/